import { BackofficeGetGroupPromoTableMechanismResponse } from '@diamond/shared/types';
import { apiInstance } from '@diamond/shared/utils';
import { useAuthStore } from '@diamond/sol-admin/features/auth';
import { useQuery } from '@tanstack/react-query';

export const getTableMechanism = async (
  token: string,
  id: string,
  page: number,
  size: number,
  search_query?: string
) => {
  const url = `backoffice/promo/${id}/table-mechanism`;
  const { data } = await apiInstance(
    token
  ).get<BackofficeGetGroupPromoTableMechanismResponse>(url, {
    params: {
      page,
      size,
      search_query,
    },
  });
  return data;
};

export const BACKOFFICE_GROUP_PROMO_TABLE_MECHANISM_KEY =
  'BackofficeGroupPromoTableMechanism';

export function useGroupPromoTableMechanism(
  promoId: string,
  page: number,
  size: number,
  search_query?: string
) {
  const { access_token } = useAuthStore();
  return useQuery({
    queryKey: [
      BACKOFFICE_GROUP_PROMO_TABLE_MECHANISM_KEY,
      promoId,
      page,
      size,
      search_query,
    ],
    queryFn: () =>
      getTableMechanism(access_token, promoId, page, size, search_query),
    enabled: !!promoId,
    gcTime: 0,
    staleTime: 5 * 60 * 1000,
    retry: 3,
  });
}
